import React, { useEffect, useState } from 'react';
import { ReactSVG } from 'react-svg';
import { Link } from 'react-router-dom';
import { passwordResetRequest } from '../../Common/requests'
import { usePostHog } from '@posthog/react';
import ArrowSVG from '../../assets/icons/arrow-up.svg'
import SimpleReactValidator from "simple-react-validator";
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const ForgotPassword = () => {
    const { t } = useTranslation('marketplace');
    const posthog = usePostHog();
    const [validator] = useState(new SimpleReactValidator());
    const [disabled, setDisabled] = useState(false);
    const [, forceUpdate] = useState();

    const [username, setUsername] = useState('');
    const [phone, setPhone] = useState('');
    const [isEmailSent, setIsEmailSent] = useState(false)

    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    function updateStates() {
        toast.error(t('auth.usernameOrPhoneRequired'))
        forceUpdate(1);
        setDisabled(false);
    }

    const handleLogin = async (evt) => {
        if (typeof evt !== "undefined" && evt != null) {
            evt.preventDefault();
        }
        let data = { email: username, phone, marketplace: true };

        if (!username) {
            if (!phone) {
                updateStates()
                evt.preventDefault();
                return
            } else if (phone && !username) {
                setDisabled(true);
                try {
                    const response = await passwordResetRequest(data);
                    if (response.status === 200) {
                        posthog?.capture('password_reset_requested', { method: 'phone' });
                        setDisabled(false);
                        setIsEmailSent(true)
                    }
                } catch (e) {
                    setDisabled(false);
                }
            } else {
                updateStates()
                evt.preventDefault();
                return
            }
        } else {
            setDisabled(true);
            try {
                const response = await passwordResetRequest(data);
                if (response.status === 200) {
                    posthog?.capture('password_reset_requested', { method: 'email' });
                    setDisabled(false);
                    setIsEmailSent(true)
                }
            } catch (e) {
                setDisabled(false);
            }
        }
    }

    return (
        <div className="auth-page">
            <div className="container">
                <div className="block-content inner-head">
                    <Link className="icon" to="/login">
                        <ReactSVG src={ArrowSVG} />
                    </Link>
                </div>

                {isEmailSent ? <div className="block-content content-holder text-center">
                    <h2>
                        {username ? t('auth.emailSentTitle') : t('auth.otpSentTitle')}
                    </h2>
                    <p>
                        {username ? <span>{t('auth.emailSentTo')} <b>{username}</b></span> : <span>{t('auth.otpSentTo')} <b>{phone}</b></span>}
                        {username ? ` ${t('auth.followLinkInEmail')}` : t('auth.useOtpForReset')}
                    </p>
                </div> :
                    <div className="block-content content-holder">
                        <h2>
                            {t('auth.forgotPasswordTitle')}
                        </h2>
                        <p>
                            {t('auth.forgotPasswordSubtitle')}
                        </p>
                        <form onSubmit={handleLogin} noValidate>
                            <div className="form-group">
                                <label>{t('auth.email')}</label>
                                <input type="email" className="form-control" placeholder={t('auth.email')} value={username} onChange={(e) => { setUsername(e.target.value); setPhone("") }} />
                            </div>
                            <h5 className="text-center">
                                {t('auth.or')}
                            </h5>
                            <div className="form-group">
                                <label>{t('auth.phone')}</label>
                                <input type="text" className="form-control" placeholder={t('auth.phone')} value={phone} onChange={(e) => { setPhone(e.target.value); setUsername("") }} />
                            </div>
                            <div className="button-holder mt-3">
                                <button type="submit" className="btn btn-secondary" disabled={disabled}>{t('auth.resetPasswordButton')}</button>
                            </div>
                        </form>
                    </div>
                }
                <h6 className="text-grey text-center"> {t('auth.copyrightNotice')}</h6>
            </div>
        </div>
    );
}

export default ForgotPassword;
